module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"omitted_count":"and {0} other products","write_review":"Go to write reviews"}}')
  delete Component.options._Ctor
}
